import {
  DesignedButton,
  DesignedIcon,
  ReusableGlossBox,
  Rule,
} from "@with-nx/simple-ui/atoms";
import { Col, Row } from "antd";
import { ReactNode } from "react";
import { FiInfo } from "react-icons/fi";
import { Box } from "simple-effing-primitive-layout";

interface ReusablePricingBoxProps {
  popular?: boolean;
  title?: string;
  price: string;
  label?: string;
  description?: string;
  disclaimer?: string;
  onPurchaseNow?: () => unknown;
  onCart?: () => unknown;
  cart?: boolean;
  onPurchaseWithRepresentative?: () => unknown;
  onLearnMore?: () => unknown;
  features: string[];
  span?: number;
  minimal?: boolean;
  children?: ReactNode;
  mode?:
    | "top-left-yellow"
    | "top-left-purple"
    | "top-left-green"
    | "top-left-blue"
    | "top-left-grey";
  purchaseNowLabel?: string;
  featuresLabel?: string;
  cypress?: string;
  subtext?: string;
  preFeaturesDescription?: string;
}

export const ReusablePricingBox = (props: ReusablePricingBoxProps) => {
  const {
    popular = false,
    title,
    price,
    label = "4-week license",
    description,
    onLearnMore,
    onPurchaseWithRepresentative,
    onPurchaseNow,
    features = [],
    span = 24,
    mode = "top-left-yellow",
    cart = false,
    onCart,
    minimal = false,
    children,
    disclaimer,
    purchaseNowLabel,
    featuresLabel = "Features:",
    subtext,
    cypress,
    preFeaturesDescription,
  } = props;
  return (
    <ReusableGlossBox
      mode={mode}
      parse="br:10 oa:hidden o:hidden d:flex fd:column h:100%"
    >
      <Box parse="pa:32 f:1">
        <Box css="d:flex a:center j:space-between">
          <Rule rule="ll" parse="mh:28" line={28}>
            {title || ""}
          </Rule>

          {popular ? (
            <svg width="87" height="25" viewBox="0 0 87 25" fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.5626 6.04765C16.797 6.14942 16.9363 6.39358 16.9046 6.6472L16.4098 10.6061H20.9393C21.1627 10.6061 21.366 10.7353 21.4607 10.9376C21.5555 11.1399 21.5247 11.3788 21.3817 11.5504L15.6241 18.4595C15.4605 18.6558 15.187 18.7208 14.9525 18.619C14.7181 18.5172 14.5788 18.2731 14.6105 18.0195L15.1053 14.0606H10.5758C10.3524 14.0606 10.1491 13.9314 10.0544 13.7291C9.95961 13.5267 9.99044 13.2879 10.1335 13.1163L15.891 6.2072C16.0546 6.01085 16.3281 5.94587 16.5626 6.04765Z"
                fill="white"
              />
              <path
                d="M32.632 13.612V12.114H34.802C35.2687 12.114 35.6513 11.9553 35.95 11.638C36.2487 11.3207 36.398 10.91 36.398 10.406C36.398 10.0607 36.3187 9.762 36.16 9.51C36.0107 9.24867 35.8007 9.04333 35.53 8.894C35.2593 8.74467 34.9467 8.67467 34.592 8.684H32.632V7.2L34.62 7.186C35.292 7.186 35.8847 7.326 36.398 7.606C36.9113 7.87667 37.3127 8.25467 37.602 8.74C37.8913 9.216 38.036 9.77133 38.036 10.406C38.036 11.022 37.9007 11.5727 37.63 12.058C37.3593 12.5433 36.9813 12.926 36.496 13.206C36.02 13.4767 35.4647 13.612 34.83 13.612H32.632ZM31.162 17V7.2H32.786V17H31.162ZM42.2638 17.168C41.5638 17.168 40.9384 17.014 40.3878 16.706C39.8464 16.3887 39.4218 15.9547 39.1138 15.404C38.8058 14.8533 38.6518 14.2187 38.6518 13.5C38.6518 12.7813 38.8011 12.1467 39.0998 11.596C39.4078 11.0453 39.8324 10.616 40.3738 10.308C40.9151 9.99067 41.5358 9.832 42.2358 9.832C42.9358 9.832 43.5564 9.99067 44.0978 10.308C44.6391 10.616 45.0591 11.0453 45.3578 11.596C45.6658 12.1467 45.8198 12.7813 45.8198 13.5C45.8198 14.2187 45.6704 14.8533 45.3718 15.404C45.0731 15.9547 44.6531 16.3887 44.1118 16.706C43.5704 17.014 42.9544 17.168 42.2638 17.168ZM42.2638 15.726C42.6464 15.726 42.9871 15.6327 43.2858 15.446C43.5844 15.25 43.8178 14.9887 43.9858 14.662C44.1538 14.326 44.2378 13.9387 44.2378 13.5C44.2378 13.0613 44.1491 12.6787 43.9718 12.352C43.8038 12.016 43.5704 11.7547 43.2718 11.568C42.9731 11.372 42.6278 11.274 42.2358 11.274C41.8438 11.274 41.4984 11.3673 41.1998 11.554C40.9011 11.7407 40.6678 12.002 40.4998 12.338C40.3318 12.674 40.2478 13.0613 40.2478 13.5C40.2478 13.9387 40.3318 14.326 40.4998 14.662C40.6771 14.9887 40.9151 15.25 41.2138 15.446C41.5218 15.6327 41.8718 15.726 42.2638 15.726ZM47.2485 19.8V10H48.7185L48.8165 11.288V19.8H47.2485ZM51.0285 17.168C50.4405 17.168 49.9319 17.0187 49.5025 16.72C49.0825 16.412 48.7605 15.9827 48.5365 15.432C48.3125 14.8813 48.2005 14.2373 48.2005 13.5C48.2005 12.7533 48.3125 12.1093 48.5365 11.568C48.7605 11.0173 49.0825 10.5927 49.5025 10.294C49.9319 9.986 50.4405 9.832 51.0285 9.832C51.6632 9.832 52.2139 9.986 52.6805 10.294C53.1565 10.5927 53.5252 11.0173 53.7865 11.568C54.0572 12.1093 54.1925 12.7533 54.1925 13.5C54.1925 14.2373 54.0572 14.8813 53.7865 15.432C53.5252 15.9827 53.1565 16.412 52.6805 16.72C52.2139 17.0187 51.6632 17.168 51.0285 17.168ZM50.6365 15.74C51.0099 15.74 51.3412 15.6467 51.6305 15.46C51.9199 15.264 52.1485 14.998 52.3165 14.662C52.4939 14.326 52.5825 13.9387 52.5825 13.5C52.5825 13.0613 52.4985 12.674 52.3305 12.338C52.1719 12.002 51.9479 11.7407 51.6585 11.554C51.3692 11.3673 51.0332 11.274 50.6505 11.274C50.2959 11.274 49.9785 11.3673 49.6985 11.554C49.4185 11.7407 49.1992 12.002 49.0405 12.338C48.8912 12.674 48.8165 13.0613 48.8165 13.5C48.8165 13.9387 48.8912 14.326 49.0405 14.662C49.1992 14.998 49.4139 15.264 49.6845 15.46C49.9645 15.6467 50.2819 15.74 50.6365 15.74ZM60.2221 17L60.1381 15.712V10H61.6921V17H60.2221ZM55.3781 14.004V10H56.9461V13.584L55.3781 14.004ZM56.9461 13.584C56.9461 14.1347 57.0114 14.564 57.1421 14.872C57.2727 15.18 57.4501 15.3947 57.6741 15.516C57.9074 15.6373 58.1734 15.698 58.4721 15.698C59.0041 15.7073 59.4147 15.5347 59.7041 15.18C59.9934 14.8253 60.1381 14.3167 60.1381 13.654H60.7261C60.7261 14.3913 60.6141 15.026 60.3901 15.558C60.1754 16.0807 59.8674 16.482 59.4661 16.762C59.0741 17.0327 58.6027 17.168 58.0521 17.168C57.2027 17.168 56.5447 16.9067 56.0781 16.384C55.6114 15.8613 55.3781 15.068 55.3781 14.004L56.9461 13.584ZM63.4344 17V7.2H65.0024V17H63.4344ZM70.985 17L70.915 15.684V13.402C70.915 12.926 70.8637 12.5293 70.761 12.212C70.6583 11.8947 70.495 11.652 70.271 11.484C70.0563 11.316 69.7717 11.232 69.417 11.232C69.0903 11.232 68.801 11.302 68.549 11.442C68.297 11.582 68.087 11.7967 67.919 12.086L66.491 11.582C66.6497 11.274 66.855 10.9847 67.107 10.714C67.359 10.4433 67.6763 10.2287 68.059 10.07C68.451 9.91133 68.913 9.832 69.445 9.832C70.1263 9.832 70.691 9.958 71.139 10.21C71.5963 10.462 71.937 10.8353 72.161 11.33C72.385 11.8247 72.497 12.436 72.497 13.164L72.455 17H70.985ZM68.997 17.168C68.157 17.168 67.5037 16.9813 67.037 16.608C66.5797 16.2347 66.351 15.7073 66.351 15.026C66.351 14.298 66.5937 13.7427 67.079 13.36C67.5737 12.9773 68.2597 12.786 69.137 12.786H71.013V13.99H69.641C69.0157 13.99 68.577 14.0787 68.325 14.256C68.073 14.424 67.947 14.6667 67.947 14.984C67.947 15.2547 68.0543 15.4693 68.269 15.628C68.493 15.7773 68.801 15.852 69.193 15.852C69.5383 15.852 69.837 15.7727 70.089 15.614C70.3503 15.446 70.551 15.2313 70.691 14.97C70.8403 14.6993 70.915 14.41 70.915 14.102H71.489C71.489 15.054 71.2837 15.8053 70.873 16.356C70.4717 16.8973 69.8463 17.168 68.997 17.168ZM75.1208 13.276C75.1208 12.52 75.2655 11.8993 75.5548 11.414C75.8441 10.9287 76.2175 10.5693 76.6748 10.336C77.1415 10.0933 77.6268 9.972 78.1308 9.972V11.47C77.7015 11.47 77.2955 11.5307 76.9128 11.652C76.5395 11.764 76.2361 11.9507 76.0028 12.212C75.7695 12.4733 75.6528 12.8187 75.6528 13.248L75.1208 13.276ZM74.0848 17V10H75.6528V17H74.0848Z"
                fill="white"
              />
              <rect
                x="0.5"
                y="0.5"
                width="86"
                height="24"
                rx="3.5"
                stroke="#AFAFAF"
              />
            </svg>
          ) : undefined}
        </Box>
        <Box css="d:flex a:baseline" parse="mt:16">
          <Rule rule="ll" size={48} line={56}>
            {price}
          </Rule>
          <Rule rule="lm" parse="ml:5">
            {label}
          </Rule>
        </Box>
        {disclaimer || description ? (
          <Rule
            rule="lm"
            parse="d:block mt:20 ml:5 mh:40 c:?font2 d:flex a:center"
          >
            {disclaimer ? (
              <FiInfo
                color="var(--font2)"
                size={14}
                style={{ marginRight: 6 }}
                title="info icon"
              />
            ) : undefined}{" "}
            {disclaimer || description}
          </Rule>
        ) : undefined}
        {minimal ? undefined : (
          <Box
            parse="pb:32 mt:32"
            style={{ borderBottom: "1px solid #2D3542" }}
          >
            <Row gutter={[16, 16]}>
              {cart ? (
                <Col>
                  <DesignedButton
                    label="Added to Cart"
                    size="large"
                    theme="positive"
                    properties={{
                      width: "100%",
                      display: "block",
                      align: "center",
                      justify: "center",
                      left: 10,
                      style: {
                        justifyContent: "center",
                        width: "100%",
                      },
                      native: {
                        cypress: cypress ? `button-${cypress}` : undefined,
                      },
                    }}
                    container={{
                      style: { width: "100%", display: "block" },
                    }}
                    press={onCart}
                  />
                </Col>
              ) : onPurchaseNow ? (
                <Col>
                  <DesignedButton
                    label={purchaseNowLabel || "Add to Cart"}
                    icon="cart"
                    size="large"
                    theme="primary"
                    properties={{
                      width: "100%",
                      display: "flex",
                      align: "center",
                      justify: "center",
                      left: 10,
                      style: {
                        justifyContent: "center",
                        width: "100%",
                      },
                      native: {
                        cypress: cypress ? `button-${cypress}` : undefined,
                      },
                    }}
                    container={{
                      style: { width: "100%", display: "block" },
                    }}
                    press={onPurchaseNow}
                  />
                </Col>
              ) : undefined}
              {onPurchaseWithRepresentative ? (
                <Col>
                  <DesignedButton
                    label="Request Proposal"
                    size="large"
                    theme="tetriary"
                    properties={{
                      width: "100%",
                      display: "block",
                      align: "center",
                      justify: "center",
                      left: 10,
                      style: {
                        justifyContent: "center",
                        width: "100%",
                      },
                    }}
                    container={{
                      style: { width: "100%", display: "block" },
                    }}
                    press={onPurchaseWithRepresentative}
                  />
                </Col>
              ) : undefined}
            </Row>
          </Box>
        )}

        {preFeaturesDescription ? (
          <Rule
            rule="lm"
            parse="d:block mt:20 ml:5 mh:40 c:?font2 d:flex a:center"
          >
            {preFeaturesDescription}
          </Rule>
        ) : undefined}

        <Rule rule="lm" parse="d:block mt:24 mb:12 c:?font3">
          {featuresLabel}
        </Rule>

        <Row gutter={[10, 10]}>
          {features.map((item) => (
            <Col key={item} xs={span}>
              <Box css="d:flex align-items:baseline" key={item}>
                <Box parse="w:24 h:24 mnw:24 mnh:24">
                  <DesignedIcon
                    name="check/bold"
                    color="var(--positive)"
                    size={24}
                  />
                </Box>
                <Rule rule="lm" parse="d:block ml:10 c:?font1">
                  {item}
                </Rule>
              </Box>
            </Col>
          ))}
        </Row>

        {subtext ? (
          <Rule
            rule="lm"
            parse="d:block mt:20 ml:5 mh:40 c:?font2 d:flex a:center"
          >
            {subtext}
          </Rule>
        ) : undefined}

        {children}
      </Box>
      {onLearnMore ? (
        <Box
          parse="pa:16 c:#2D3542 d:flex a:center j:center"
          press={onLearnMore}
        >
          <Rule rule="lm">Learn more</Rule>
        </Box>
      ) : undefined}
    </ReusableGlossBox>
  );
};

export default ReusablePricingBox;
